<template>
    <b-row>
        <b-col cols="12">
            <b-alert show :variant="color">
                <h5 v-if="url?.includes('carrito')">{{ mensaje }}</h5>
                <h3 v-else>{{ mensaje }}</h3>
            </b-alert>
        </b-col>
        <b-col cols="12" v-if="error">
            <b-button @click="pago">Intentar de nuevo</b-button>
        </b-col>
        <b-col cols="12" v-if="continuar">
            <b-button @click="$emit('pagoCorrecto', null);">Realizar pago de forma manual</b-button>
        </b-col>
    </b-row>   
</template>

<script>
    import * as Tpvpc from '@/assets/redsys/tpvpc-impl.js'

    export default {
        props: {
            importe: {
                required: true,
                type: Number
            }
        },
        data() {
            return {
                datafono: null,
                error: false,
                color: 'primary',
                mensaje: 'Iniciando datafono...',
                continuar: false,
                iniciado: false
            }
        },
        computed: {
            datafono_data() {
                return this.$store.getters.getDatafono;
            },
            url() {
                return window.location.href;
            }
        },  
        created() {
            if(this.datafono_data) {
                this.datafono = new Tpvpc.TpvpcImplantado();
                this.datafono.EnableLog();

                this.init(this.datafono_data.comercio, this.datafono_data.terminal.toString(), this.datafono_data.key, this.datafono_data.puerto, this.datafono_data.version);
            } else {
                this.color = 'danger';
                this.mensaje = 'Este usuario no tienen ningún datafono asignado.';
            }        
        },
        methods: {
            init(comercio, terminal, key, puerto, version) {
                this.datafono.initFnDll([comercio, terminal, key, puerto ?? '', version ?? ''], ret => {
                    if(ret.Response == 0) {
                        this.iniciado = true;
                        this.pago();
                    } else {
                        this.continuar = true;
                        this.color = 'danger';
                        this.mensaje = 'Error al conectar con el datafono.'
                    }
                }, comercio)
            },
            pago() {
                this.error = false;
                this.color = 'primary';
                this.mensaje = 'Esperando una lectura de tarjeta.'

                let importeFormateado = this.importe.toFixed(2);

                this.datafono.execFnDll('fnDllOperPinPad', [importeFormateado, '', 'PAGO'], ret => {
                    const response = this.xmlStringToJson(ret.Result);

                    if(response.resultadoOperacion && response.resultadoOperacion.resultado == 'Autorizada' && response.resultadoOperacion.estado == 'F') {
                        this.color = 'success';
                        this.mensaje = 'Pago realizado correctamente.';
                        this.$emit('pagoCorrecto', response.resultadoOperacion);
                    } else if(response.resultadoOperacion && response.resultadoOperacion.estado != 'F') {
                        this.color = 'danger';
                        this.error = true;
                        this.mensaje = 'Operación denegada, ' + response.resultadoOperacion.codigoRespuesta;
                    } else if(response.resultadoOperacion && response.resultadoOperacion.resultado == 'Denegada') {
                        this.color = 'danger';
                        this.error = true;
                        switch (String(response.resultadoOperacion.codigoRespuesta)) {
                            case "117":
                                this.mensaje = 'Operación denegada, 117 - Pin incorrecto';
                                break;                    
                            case "101":
                                this.mensaje = 'Operación denegada, 101 - Tarjeta caducada';
                                break;
                            default:
                                this.mensaje = 'Operación denegada, ' + response.resultadoOperacion.codigoRespuesta;
                                break;
                        }
                    
                    } else {
                        this.color = 'danger';
                        this.error = true;
                        this.mensaje = response.Error.mensaje;
                    }
                })
            },
            xmlStringToJson(xmlString) {
                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(xmlString, "text/xml");

                function xmlToJson(xmlNode) {
                    let obj = {};

                    if (xmlNode.attributes) {
                        for (let i = 0; i < xmlNode.attributes.length; i++) {
                            let attribute = xmlNode.attributes.item(i);
                            obj[`@${attribute.nodeName}`] = attribute.nodeValue;
                        }
                    }

                    if (xmlNode.hasChildNodes()) {
                        for (let i = 0; i < xmlNode.childNodes.length; i++) {
                            let childNode = xmlNode.childNodes.item(i);

                            if (childNode.nodeType === 3) {
                                let textValue = childNode.nodeValue.trim();
                                if (textValue) {
                                    obj = textValue;
                                }
                            } else {
                                let nodeName = childNode.nodeName;
                                if (typeof obj[nodeName] === "undefined") {
                                    obj[nodeName] = xmlToJson(childNode);
                                } else {
                                    if (!Array.isArray(obj[nodeName])) {
                                        obj[nodeName] = [obj[nodeName]];
                                    }
                                    obj[nodeName].push(xmlToJson(childNode));
                                }
                            }
                        }
                    }

                    return obj;
                }

                return xmlToJson(xmlDoc.documentElement);
            }
        }
    }
</script>